// The pages listed on /faqs, in the order they appear there: the FAQ Platform
// page first, then the warrant-article FAQs by article number, then the CHCA
// FAQ, which belongs to no article.
//
// They used to sit in Home's own ALL_PAGES; they were moved here on 2026-10-18
// so Home carries one "Brookline Notepad FAQs" card in their place and the two
// lists cannot drift apart. Each entry is the same shape Home uses:
// {path, title, description, icon}.
//
// All five are public today. The FAQ Platform page is the odd one: it explains
// the hosting offer rather than a warrant article, and carries the Submit tab.
export const FAQ_PAGES = [
  {
    path: '/faq-platform-faq',
    title: 'FAQ Platform',
    description: 'For petitioners hosting a FAQ for their warrant article - how it works, and where to submit content',
    icon: '❓',
  },
  {
    path: '/2026-stm2-reimburse-tmms-faq',
    title: 'Reimbursing Town Meeting Members FAQ',
    description: 'Warrant Article 5 - urging the Select Board to reimburse five Town Meeting Members for legal expenses',
    icon: '✍️',
  },
  {
    path: '/2026-stm2-crypto-kiosk-faq',
    title: 'Cryptocurrency Kiosk FAQ',
    description: 'Warrant Article 7 - proposed ban on cryptocurrency kiosks - Frequently Asked Questions',
    icon: '🏧',
  },
  {
    path: '/outdoor-lighting-faq',
    title: 'Outdoor Lighting FAQ',
    description: 'Warrant Articles 12 and 13 - proposed outdoor lighting standards in the General and Zoning By-laws',
    icon: '💡',
  },
  {
    path: '/2026-stm2-psmod-faq',
    title: 'Pleasant Street Multifamily Overlay FAQ',
    description: 'Warrant Articles 15 and 16 - a proposed overlay district at 26 Pleasant Street, and the Town\u2019s agreement with the owner',
    icon: '\ud83c\udfd8\ufe0f',
  },
  {
    path: '/chca-faq',
    title: 'CHCA FAQ',
    description: 'Chestnut Hill Commercial Area - Frequently Asked Questions',
    icon: '📋',
  },
];
